export default __webpack_public_path__ + "static/media/open-enrollment.cb2f2118.png";